module.exports = __webpack_public_path__ + "static/media/composto-bg.d4a37715.png";